var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"1"}},[_c('v-radio',{attrs:{"disabled":_vm.isDisabledd,"value":_vm.value}})],1),_c('v-col',{attrs:{"cols":"11"}},[_c('latex-html',{attrs:{"hasClass":_vm.hasClass,"isLatex":_vm.isLatex,"html":_vm.html}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }